export enum TabType {
    Tv = 0,
    Archive = 3,
    Live = 1
}